import { ApiResult, CrudService } from 'ui-shared';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { PdmVersaoAtributoEntity } from '@catalogo/models';
import { PdmVersaoDescricaoEntity } from '@catalogo/models/pdm-versao-descricao.entity';
import { OPERACAO_API_URL } from "@catalogo/features/compartilhado/const/constantes";

@Injectable({ providedIn: 'root', })
export class PdmVersaoAtributoDataService extends CrudService<PdmVersaoAtributoEntity> {

    protected url: string;

    private urlReplace: string;

    constructor(
        @Inject(OPERACAO_API_URL) public urlBase: string,
        @Inject(HttpClient) protected httpClient: HttpClient
    ) {
        super(urlBase, httpClient);
        this.urlReplace = `${urlBase}/v1/pdm/versao/<parent>/atributo`;
    }

    public withParentId(id) {
        this.url = this.urlReplace.replace('<parent>', id);
        return this;
    }
    public createOrUpdate = (pdmAtributos: PdmVersaoAtributoEntity[], pdmVersaoId: string,
                             pdmDescricoes: PdmVersaoDescricaoEntity[], atributoUnico: boolean = false) =>
        this.httpClient.post<ApiResult<LotePdmAtributoResult>>(this.url.concat('s'), <AdicionarOuAtualizarPdmAtributoCommand>{
            pdmVersaoId,
            pdmAtributos,
            pdmDescricoes,
            atributoUnico
        });

    public gerarDescricaoAtributo = (pdmAtributos: PdmVersaoAtributoEntity[], pdmVersaoId: string, compoeDescricao: boolean, tipoDescricaoId: string, detalhamentoComplementarProduto: boolean, posicaoDescricao: string) =>
        this.httpClient.post<ApiResult<AtributosPreviewDescricaoResult>>(this.url.concat('s/PreviewDescricao'), {
            pdmAtributos,
            compoeDescricao,
            tipoDescricaoId,
            pdmVersaoId,
            detalhamentoComplementarProduto,
            posicaoDescricao
        });
}

export class AdicionarOuAtualizarPdmAtributoCommand {
    pdmVersaoId: string;
    pdmAtributos: PdmVersaoAtributoEntity[];
    pdmDescricoes: PdmVersaoDescricaoEntity[];
    atributoUnico: boolean;
}

export class LotePdmAtributoResult {
    results: { pdmAtributo: PdmVersaoAtributoEntity; sucesso: boolean; erros: string[]; }[];
}

export class AtributosPreviewDescricaoResult {
    descricao: string;
    tamanho:number;
    mensagemErro: string;
    tipoDescricaoId: string;
}
